export const reservationDrawer = {
  title: "Booking details",
  openFullPage: "Open in full page",
  close: "Close",
};
